import $ from 'jquery';

$( function () {
	let selectedStoreOpeningHours = seats.available_days_standard;

	let $megastoreSelectField = $( '.seatssofas_megastore_appointment_field select' );

	let $megastoreFormDateField = $( '#input_' + seats.megastore_form + '_' + seats.megastore_datepicker_field_id );
	let $megastoreFormTimeField = $( '#input_' + seats.megastore_form + '_' + seats.megastore_select_time_field_id );

	let $megastoreFormDateFieldHomepage = $( '#input_' + seats.megastore_form_homepage + '_' + seats.megastore_datepicker_field_id_homepage );
	let $megastoreFormTimeFieldHomepage = $( '#input_' + seats.megastore_form_homepage + '_' + seats.megastore_select_time_field_id_homepage );

	let dateField;
	let timeField;

	if ( $megastoreFormDateField.length ) {
		dateField = $megastoreFormDateField;
	} else if ( $megastoreFormDateFieldHomepage.length ) {
		dateField = $megastoreFormDateFieldHomepage;
	}

	if ( $megastoreFormTimeField.length ) {
		timeField = $megastoreFormTimeField;
	} else if ( $megastoreFormTimeFieldHomepage.length ) {
		timeField = $megastoreFormTimeFieldHomepage;
	}

	if ( dateField === undefined || timeField === undefined ) {
		return;
	}

	// Megastore select
	$megastoreSelectField.on( 'change', function () {
		dateField.val( '' );
		timeField.val( '' );

		getMegastoreDetails( $( this ).val() );
	} );

	// Date select
	dateField.on( 'change', function () {
		let selectedDate = $( this ).val();

		changeAvailableTimeSlots( selectedDate );
	} );

	// Show modal
	$( '#formModal' ).on( 'shown.bs.modal', function () {
		getMegastoreDetails( $( '.seatssofas_megastore_appointment_field select option:selected' ).val() );
	} );

	const getMegastoreDetails = ( selectedMegastore ) => {
		if ( !selectedMegastore ) {
			changeAvailableDates();
			return;
		}

		$.ajax( `${seats.rest_url}/megastore/${selectedMegastore}/`, {
			method: 'GET',
			cache: false,
			data: {
				_wpnonce: seats.rest_nonce
			}
		} ).always( data => {
			if ( data && data.success ) {
				selectedStoreOpeningHours = data.store_details.opening_hours;

				changeAvailableDates();
			}
		} );
	}

	const changeAvailableDates = () => {
		const weekdays = [ 'sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday' ];
		const daysAdjustment = seats.available_days_adjustment;

		let daysNormal = selectedStoreOpeningHours; //De dagen vanuit de openingstijden op megastore detail.

		if ( !daysNormal ) {
			return;
		}

		daysNormal = Object.keys( daysNormal ).reduce( ( item, index ) => {
			item[ index ] = daysNormal[ index ].open;
			return item;
		}, {} );

		if ( daysAdjustment ) { //Haal de mogelijke afspraakdagen uit de opties.
			daysNormal = seats.available_days; //De dagen uit de opties als eerste alternatief.
		}

		let availableDays = [];

		if ( daysNormal ) {
			weekdays.forEach( function ( item, index ) {
				if ( daysNormal[ item ] ) {
					availableDays.push( index );
				}
			} );
		}

		dateField.datepicker( 'option', 'beforeShowDay', function ( date ) {
					const day = date.getDay();

					return [ ( availableDays.indexOf( day ) !== -1 ) ];
				}
		);

		changeAvailableTimeSlots( dateField.val() );
	}

	const changeAvailableTimeSlots = ( selectedDate ) => {
		timeField.prop( 'selectedIndex', 0 ); //reset selected time field!

		// Reset choices
		timeField.find( 'option' ).attr( "disabled", false );

		if ( selectedDate !== '' ) {
			var parts = selectedDate.split( '/' );

			// Pay attention to the month (parts[1]); JavaScript counts months from 0
			selectedDate = new Date( parts[ 2 ], parts[ 1 ] - 1, parts[ 0 ] );

			var selectedDateOnly = selectedDate;
			selectedDateOnly.setHours( 0, 0, 0, 0 );

			var daysMap = { 0: 'sunday', 1: 'monday', 2: 'tuesday', 3: 'wednesday', 4: 'thursday', 5: 'friday', 6: 'saturday' };

			var selectedDay = daysMap[ selectedDate.getDay() ];

			if ( selectedDay === undefined ) {
				return;
			}

			var openingHoursMegastore = selectedStoreOpeningHours[ selectedDay ];

			if ( openingHoursMegastore === undefined ) {
				return;
			}

			let opening_time = openingHoursMegastore.opening_time;
			let closing_time = openingHoursMegastore.closing_time;

			if ( opening_time === undefined || closing_time === undefined ) {
				return;
			}

			opening_time = opening_time.split( ':' );
			closing_time = closing_time.split( ':' );

			let storeOpeningDate = new Date();
			storeOpeningDate.setHours( opening_time[ 0 ] );
			storeOpeningDate.setMinutes( opening_time[ 1 ] );
			storeOpeningDate.setSeconds( 0 );

			let storeClosingDate = new Date();
			storeClosingDate.setHours( closing_time[ 0 ] );
			storeClosingDate.setMinutes( closing_time[ 1 ] );
			storeClosingDate.setSeconds( 0 );

			timeField.children( 'option' ).each( function () {
				let timeString = $( this ).val();
				timeString = timeString.split( ':' );

				let appointmentDate = new Date();
				appointmentDate.setHours( parseInt( timeString[ 0 ] ) );
				appointmentDate.setMinutes( parseInt( timeString[ 1 ] ) + 1 );
				appointmentDate.setSeconds( 0 );

				if ( appointmentDate < storeOpeningDate || appointmentDate > storeClosingDate ) {
					$( this ).attr( 'disabled', true );
				}
			} );
		}
	}

	const megastoreValue = $megastoreSelectField.val();

	if ( megastoreValue ) {
		getMegastoreDetails( megastoreValue );
	}

} );